
    import './styles.scoped.css';
    export default {
  "info": "awsui_info_1fhsi_16fog_5",
  "item-icon": "awsui_item-icon_1fhsi_16fog_9"
};
  